import { DateTime } from 'luxon';

type DateComponents = {
  year: number;
  month?: number;
  day?: number;
};

type DateFormatOptions = Partial<Intl.DateTimeFormatOptions>;

export function formatDate(dateComponents: DateComponents, locale: string): string {
  const { year, month, day } = dateComponents;
  
  const dt = DateTime.fromObject({
    year,
    month: month ?? 1,
    day: day ?? 1,
  });
  
  const isBC = year < 0;
  const eraOption: DateFormatOptions = isBC ? { era: 'short' } : {};
  
  const formatOptions: DateFormatOptions = {
    year: 'numeric',
    ...(month && { month: 'long' }),
    ...(day && { day: 'numeric' }),
    ...eraOption,
  };

  return dt.toLocaleString(formatOptions, { locale });
}
